import {Component, OnInit} from "@angular/core";
import {DossierService} from "../../../../../../services";
import {DictionaryService} from "@amlCore/services";
import {AlertPanelService, ITableEditorItem, ITableItem} from "@amlCore/components";
import {DossierBaseModel} from "../../../dossierBaseModel";
import {FormGroup} from "@angular/forms";
import {DossierBaseSubComponent} from "../../dossierBaseSub.component";
import {SostavIOType} from "../../../../../../models";

@Component({
  selector: 'app-sostavio-info-dossier',
  styleUrls: ['../../../dossier.css'],
  templateUrl: './sostavIOInfoDossier.component.html'
})
export class SostavIOInfoDossierComponent extends DossierBaseSubComponent implements ITableItem, OnInit {

  titlePanel = 'Состав коллегиального органа управления';
  showTitle = true;
  isTableItem = false;

  constructor(protected dossierService: DossierService, protected dictSrv: DictionaryService,
              protected dossierBaseModel: DossierBaseModel,
              protected alertPanelService: AlertPanelService) {
    super(dossierService, dictSrv, alertPanelService);
  }

  /**
   * Описание формы
   */
  getFormDescription(): FormGroup {
    return this.dossierBaseModel.getSostavIOInfo();
  }

  /**
   * Инициализация FormGroup
   */
  initForm() {
    if (!this.isTableItem) {
      this.formGroupApp = this.getFormDescription();
    }
  }

  ngOnInit() {
    this.focusObject = this.generateFocusObject(new SostavIOType());
    setTimeout(() => this.initErrorFLKSimpleField());
  }

  setSubmitted(value: boolean) {
    this.submitted = value;
  }


  getTitle(): string {
    return this.titlePanel;
  }

  /**
   * Инициализируем компонент как элемент формы просмотра таблицы
   * @param param.form - форма для связи
   * @param param.params - дополнительные параметры
   */
  initTableItem(param: ITableEditorItem): FormGroup {
    this.initForm();
    this.isTableItem = true;
    if (param.model) {
      this.formGroupApp.patchValue(param.model);
    }
    this.showTitle = false;
    if (param.params && param.params.typePage) {
      this.typePage = param.params.typePage;
    }
    this.isReadOnly = param.isReadOnly;
    if (this.isReadOnly){
      this.formGroupApp.disable();
    }
    return this.formGroupApp;
  }

}
